const initialStatistics = {
  statistics: {},
  errorMessage: '',
};

export default initialStatistics;
